console.log("Custom JS loaded");

function initHeroSlider() {
    let slider = document.querySelector(".hero-slider__slides");
    let slides = slider.querySelectorAll(".hero-slide-wrapper");
    let controls = slider.querySelectorAll(".hero-slider__control");
  
    let autoplay = slider.dataset.autoplay == "true" ? true : false;
    let autoplaySpeed = slider.dataset.autoplaySpeed * 1000;
  
    let activeIndex = 0;
  
    slides[0].classList.add("active");
    slides[0].querySelector(".hero-slide").classList.remove("active");
  
    // if autoplay is enabled: autoplay with pause on hover
    if (autoplay) {
        setInterval(() => {
            if (autoplay) {
                activeIndex++;
            if (activeIndex >= slides.length) {
                activeIndex = 0;
            }
                changeHeroSlide(activeIndex, slides, controls);
            }
        }, autoplaySpeed);
  
        slider.addEventListener("mouseover", () => {
            autoplay = false;
        });
        slider.addEventListener("mouseout", () => {
            autoplay = true;
        });
    }
  
    // change slide with controls
    controls.forEach((control, index) => {
        control.addEventListener("click", () => {
            activeIndex = index;
            changeHeroSlide(activeIndex, slides, controls);
        });
    });
}
  
function changeHeroSlide(activeIndex, slides, controls) {
    slides.forEach((slide, index) => {
        if (index == activeIndex) {
            slide.classList.add("active");
        } else {
            slide.classList.remove("active");
        }
    });

    controls.forEach((control, index) => {
        if (index == activeIndex) {
            control.classList.add("active");
        } else {
            control.classList.remove("active");
        }
    });
}

/* ANCHOR DYNAMIC CARDS CAROUSEL FUNCTIONS  
1. On page load call initDynamicCardsCarousel(container) with the container of the carousel
2. Add class 'dynamic-carousel-wrapper' to div with carousel scroll 
3. Add data-scrolling="false" to the carousel wrapper
4. Add class 'dynamic-carousel-item' to each card in the carousel
5. Add class 'active' to the first card in the carousel
6. Add class 'dynamic-carousel-control' to each control button in the carousel
7. Add data-direction="next" or "prev" to each control button in the carousel

** DO NOT ADD STYLES TO THE DYNAMIC CAROUSEL CLASSES **

Example: see featured-cards.liquid section
*/
function initDynamicCardsCarousel(container) {
  let carousel = container.querySelector(".dynamic-carousel-wrapper");
  let cards = container.querySelectorAll(".dynamic-carousel-item");
  let carouselNavItems = container.querySelectorAll(".dynamic-carousel-control");
  let activeCard = carousel.querySelector(".dynamic-carousel-item.active");

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  carousel.addEventListener("scroll", () => {
    if (carousel.dataset.scrolling === "false") {
      handleDynamicCardsCarouselScroll(carousel, cards, carouselNavItems);
    }
  });

  carouselNavItems.forEach((navItem) => {
    navItem.addEventListener("click", () => {
      findDynamicCardsCarouselIndex(
        carousel,
        cards,
        navItem.dataset.direction,
        carouselNavItems
      );
    });
  });

  window.addEventListener("resize", () => {
    checkDynamicCarouselWidth(carousel, carouselNavItems);
  });
}

function checkDynamicCarouselWidth(carousel, carouselNavItems) {
  let carouselInner = carousel.querySelector(".dynamic-carousel-inner");
  let totalCarouselWidth = carouselInner.offsetWidth;
  let header = carousel.previousElementSibling;

  if (window.innerWidth >= totalCarouselWidth) {
    carousel.style.alignItems = "center";
    carousel.style.justifyContent = "center";
    carouselNavItems.forEach((navItem) => {
      navItem.style.display = "none";
    });
    if (header) {
      header.style.justifyContent = "center";
      header.style.alignItems = "center";
    }
  } else {
    carousel.style.alignItems = "";
    carousel.style.justifyContent = "";
    carouselNavItems.forEach((navItem) => {
      navItem.style.display = "";
    });
    if (header) {
      header.style.justifyContent = "";
      header.style.alignItems = "";
    }
  }
}

function findDynamicCardsCarouselIndex(carousel, cards, direction, carouselNavItems) {
  let activeCard = carousel.querySelector(".dynamic-carousel-item.active");
  let newIndex = 0;
  let carouselInner = carousel.querySelector(".dynamic-carousel-inner");
  let cardGap = parseInt(window.getComputedStyle(carouselInner).gap);
  let cardsPerView = window.innerWidth / (activeCard.offsetWidth + cardGap);

  // if cardsPerView decimal is greater than 0.9 round up
  if (cardsPerView - Math.floor(cardsPerView) > 0.9) {
    cardsPerView = Math.ceil(cardsPerView);
  } else {
    cardsPerView = Math.floor(cardsPerView);
  }

  let endIndex = cards.length - cardsPerView;

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  cards.forEach((card, index) => {
    if (card == activeCard) {
      card.classList.remove("active");
      if (direction == "next") {
        newIndex = index + 1;
        if (newIndex == cards.length) {
          newIndex = 0;
        }

        if (newIndex > endIndex) {
          newIndex = 0;
        }
      } else {
        newIndex = index - 1;
        if (newIndex < 0) {
          newIndex = cards.length - 1;
        }

        if (newIndex > endIndex) {
          newIndex = endIndex;
        }
      }
    }
  });

  cards[newIndex].classList.add("active");
  carousel.dataset.scrolling = true;
  cards[newIndex].scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
  setTimeout(() => {
    carousel.dataset.scrolling = false;
  }, 1000);
}

function handleDynamicCardsCarouselScroll(carousel, cards, carouselNavItems) {
  let activeCard = carousel.querySelector(".dynamic-carousel-item.active");
  let cardWidth = activeCard.offsetWidth;
  let scrollLeft = carousel.scrollLeft;
  let newIndex = Math.round(scrollLeft / cardWidth);
  let cardsPerView = Math.floor(window.innerWidth / cardWidth);
  let endIndex = cards.length - cardsPerView;

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  if (newIndex > endIndex) {
    newIndex = endIndex;
  } else if (newIndex < 0) {
    newIndex = 0;
  }

  cards.forEach((card, index) => {
    if (index == newIndex) {
      card.classList.add("active");
    } else {
      card.classList.remove("active");
    }
  });
}

/* END DYNAMIC CARDS CAROUSEL FUNCTIONS */

/* ANCHOR UPDATE CART COUNT IN HEADER */

function updateCartCount() {
  let cartCount = document.querySelector(".main-header--cart-count");
  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .then((data) => {
      cartCount.innerText = "(" + data.item_count + ")";
    });
}

/* ANCHOR New Collection Page Functions */
function toggleSortOptions() {
  let sortWrapper = document.querySelector(".sort-wrapper");
  if (sortWrapper.classList.contains("active")) {
    sortWrapper.classList.remove("active");
  } else {
    sortWrapper.classList.add("active");
  }

  document.addEventListener("click", (e) => {
    if (!sortWrapper.contains(e.target)) {
      sortWrapper.classList.remove("active");
    }
  });
}

function toggleFilterOptions(filter) {
  let filterWrapper = document.querySelector('.collection-filter__group--collapsible[data-filter="' + filter + '"]');
  let innerFilter = filterWrapper.querySelector(".filter__group-inner");
  if (filterWrapper.classList.contains("open")) {
    filterWrapper.classList.remove("open");
    innerFilter.setAttribute("aria-expanded", "false");
    filterWrapper.focus();
  } else {
    filterWrapper.classList.add("open");
    innerFilter.setAttribute("aria-expanded", "true");
    //let firstFilter = filterWrapper.querySelector(".filter-option");
    innerFilter.focus();
  }
}

function toggleMobileFilter(toggle) {
  let filter = document.querySelector(".filter-wrapper");
  let pageOverlay = document.querySelector(".FilterPageOverlay");
  let body = document.querySelector("body");
  let filterBtn = document.querySelector(".mobile-filter-open");

  if (toggle === "open") {
    filter.classList.add("active");
    pageOverlay.classList.add("is-visible");
    body.style.overflow = "hidden";
  } else {
    filter.classList.remove("active");
    pageOverlay.classList.remove("is-visible");
    body.style.overflow = "auto";
  }

  document.addEventListener("click", (e) => {
    if (!filter.contains(e.target) && !filterBtn.contains(e.target)) {
      filter.classList.remove("active");
      pageOverlay.classList.remove("is-visible");
      body.style.overflow = "auto";
    }
  });
}

/* ANCHOR Countdown Clock */

function initCountdownClock() {
  let countdown = document.getElementById('countdown');
  let daysElement = document.getElementById('days');
  let hoursElement = document.getElementById('hours');
  let minutesElement = document.getElementById('minutes');
  let secondsElement = document.getElementById('seconds');

  if(countdown) {
    let date = countdown.getAttribute('data-date');
    let time = countdown.getAttribute('data-time');
    let countDownDate = new Date(date + 'T' + time + '-07:00').getTime();

    let x = setInterval(function() {
      let now = new Date().getTime();
      let distance = countDownDate - now;

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysElement.innerHTML = days;
      hoursElement.innerHTML = hours;
      minutesElement.innerHTML = minutes;
      secondsElement.innerHTML = seconds;

      if (distance < 0) {
        clearInterval(x);
        daysElement.innerHTML = '00';
        hoursElement.innerHTML = '00';
        minutesElement.innerHTML = '00';
        secondsElement.innerHTML = '00';
      }
    }, 1000);
  }
}